module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns-house_spot_03-89ca3947398c3ee35702e4b7b35f810d.jpg";